import React, { Component } from "react";
import { Fab, Grid, CircularProgress } from "@material-ui/core";
import { Videocam, Sync } from "@material-ui/icons";
import axios from "axios";
import NotificationManager from 'react-notifications/src/NotificationManager';
import { fontColor, primaryColor, webFont } from "../../config/theme";
import {VIMEO_HANDLER} from "../../config/constants";

class VideoUpload extends Component {
  timer = null;
  constructor(props) {
    super(props);
    this.state = { loading: false, uploadedData: null, uploadFile: null };
  }

  setLoading = loading => {
    this.setState({ loading });
  };

  componentDidMount () {
    const { s3 } = this.props;
    if (!!s3) {
      if (s3.processing) {
        this.props.showVideoMessages('The video is processing. Please check back later.', false);
      }
    }
  }

  intervalFunc = (vidElem, file) => {
    if (vidElem.readyState === 4) {
      clearInterval(this.timer);
      let duration = 0;
      duration = Math.round(vidElem.duration);
      if (duration > 180) {
        this.props.showVideoMessages(`Video file cannot be more than 3 minutes in length or 100 MB in size. `, true);
        this.setLoading(false);
        return;
      } else {
        this.props.showVideoMessages('Please do not refresh or go to any other page while video uploads.', false);
        let formData = new FormData();
        const token = window.localStorage.getItem("ccZestyAuthToken");

        formData.append("vimeoFile", this.state.uploadFile);

        axios
          .post(`${VIMEO_HANDLER}/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": `Bearer ${token}`
            }
          })
          .then(uploadedData => {
            this.setState({ uploadedData });
            this.setLoading(false);
            this.props.onSuccess(uploadedData);
          })
          .catch(err => {
            console.log(err);
            this.props.showVideoMessages('Request timed out. Please try again uploading the video.', true);
            this.props.onError(err);
            this.setLoading(false);
          });
        this.props.onUploadStart(true);
      }
    }
  };

  readerOnLoad = e => {
    const vidElem = document.createElement('video');
    vidElem.src = e.target.result;
    this.timer = setInterval(this.intervalFunc, 500, vidElem, e.target.result);
  };

  uploadAPI = files => {
    this.setLoading(true);
    const { onSuccess, onError, onUploadStart } = this.props;
    let formData = new FormData();
    const vidFile = files[0];
    this.setState({ uploadFile: vidFile });
    var reader = new FileReader();
    var fileSize = vidFile.size;
    const fileType = vidFile.type;
    const fileName = vidFile.name;
    const fileNameArr = fileName.split('.');
    const extension = fileNameArr[fileNameArr.length - 1];

    if (fileType !== "video/mp4" && extension !== "mp4") {
      this.props.showVideoMessages('Only mp4 video files can be uploaded.', true);
      this.setLoading(false);
      return;
    }

    if (fileSize > 104857600) {
      this.setLoading(false);
      const yourFileSize = Math.round(fileSize / 1048576);
      this.props.showVideoMessages(`Video file cannot be more than 3 minutes in length or 100 MB in size. Your file size is ${yourFileSize} MB`, true);
      return;
    } else {
      reader.onload = this.readerOnLoad;

      reader.readAsDataURL(vidFile);
    }
  };

  render() {
    let { loading } = this.state;
    const {s3} = this.props;
    let failed = false;
    if (!!s3) {
      if (s3.failed) {
        failed = true;
      }
    }

    return (
      <Grid item xs={12} md={6} lg={6} style={styles.addMediaBox} className={this.props.clientWidth < 530 ? "media-cutom-col-step" : "media-cutom-col"}>
        <Grid
          container
          alignItems="center"
          justify="center"
          alignContent="center"
        >
          {(!s3 || failed) && <input
            accept="video/mp4"
            id="contained-button-video"
            type="file"
            style={{ display: "none", zIndex: 230 }}
            name="vimeoFile"
            onChange={data => {
              this.uploadAPI(data.target.files);
            }}
          />}
          {!loading && (
            <label htmlFor="contained-button-video">
              <Fab
                color="primary"
                aria-label="AddVideo"
                component="span"
                size="small"
                style={{boxShadow: 'none'}}
              >
                {!!s3 && s3.processing ? (
                  <Sync data-test-id={"addvid-id-sync"} style={styles.btnIcon} />
                ) : (
                  <Videocam data-test-id={"addvid-id"} style={styles.btnIcon} />
                )}
              </Fab>
            </label>
          )}
          {loading && <CircularProgress />}
        </Grid>
      </Grid>
    );
  }
}

export default VideoUpload;
const styles = {
  setFont: {
    fontFamily: webFont
  },
  heavy: {
    fontWeight: 800
  },
  littleHeavy: {
    fontWeight: 600
  },
  addMediaBox: {
    maxWidth: 280,
    minWidth: 280,
    height: 280,
    border: '1px solid #ff8000',
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btnPlusDishes: {
    marginLeft: 150
  },
  btnIcon: {
    color: fontColor,
  },
  btnDishType: {
    borderRadius: "50%",
    borderColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10,
    borderWidth: 1,
    borderStyle: "solid",
    color: primaryColor,
    backgroundColor: "#fff"
  },
  btnDishTypeSelected: {
    borderRadius: "50%",
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    color: fontColor,
    backgroundColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10
  },
  dishTypeDet: {
    fontSize: 10
  }
};
